export default __webpack_public_path__ + "static/media/Message.2def0105.svg";